<!-- 登录 -->
<style scoped>
  .el-container{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  .leftcontMer{
    background: url(../assets/images/login/bg_login.jpg);
    -moz-background-size:100% 100%;
    -webkit-background-size:100% 100%;
    -o-background-size:100% 100%;
    background-size:100% 100%;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: absolute;
  }
  .leftcontMer .leftCont{
    float: left;
    margin:270px 0 0 27%;
    color: #fff
  }
  .leftcontMer .leftCont .title{
    font-size: 20px;
  }
  .leftcontMer .leftCont .max{
    font-size: 54px;
    font-weight: bold;margin-top:20px;
  }
  .leftcontMer .leftCont .redFont{
    color: #F83B56;
    font-size: 20px;
  }
  .leftcontMer .leftCont .mt{
    font-size: 15px;
    margin-top: 55px;
    opacity: 0.6;
  }
  .leftcontMer .leftCont .mtsmall{
    font-size: 10px;
    opacity: 0.6;
  }
  .login-conMer {
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
    background: #fff;
  }
  .leftMe1{position: absolute;right: 14px;top:200px;}
</style>
<style>
  .login-conMer .el-tabs__nav{width: 100%;}
  .login-conMer .el-tabs__item{height: 100px;width: 50%;background: #F6F7F9;}
  .login-conMer .el-tabs--card>.el-tabs__header .el-tabs__item{border-left:0px}
  .login-conMer .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{background: #fff;}
  .zhint{color: #333; display: block;margin-top:25px;font-weight: bold;font-size: 20px;}
  .zhint img{width: 50px;vertical-align: middle;margin-right:10px}
  .storeLogin{width:100%;margin:0 auto;height: 650px;overflow: hidden;}
  .storeLogin .icon-close {
    width:14px;
    height:14px;
    display: inline-block;
    background-repeat: no-repeat;
    background-image: url("../assets/images/closeeyes.png");
  }
  .payNewIfra{display: block; border:0;width:450px;height: 650px;margin:2% auto 0;}
  .login-footMe{
    width: 100%;
    font-size: 11px;
    color: #989AA6;
    text-align: center;
    line-height: 72px;
    position: absolute;
    bottom: 5%;
    left: 0;
  }
</style>
<template>
    <el-container>
      <el-aside width="68%" style="position:relative">
        <div class="leftcontMer">
          <div class="leftCont">
            <p class="title">梅氏·云服务&nbsp;&nbsp;&nbsp;建立完善的店企服务管理体系</p>
            <p class="max">提升服务与管理的价值</p>
            <p class="redFont">service & management</p>
            <p class="mt">更快捷高效的管理模式，全体系客户服务管理平台</p>
            <p class="mtsmall">Improve the value of service and management service & management.Faster and more efficient</p>
            <p class="mtsmall">management mode, full system customer service management platform</p>
          </div>
          <span @click="loginMer(merLink + '/EnterCollege')" style="cursor: pointer;"><img src="../assets/images/login/hebin.png" class="leftMe1" /></span>
        </div>
      </el-aside>
      <div class="login-conMer">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane name="first">
            <span slot="label" class="zhint"><img src="../assets/images/login/logo1.png">智能门店管理系统</span>
            <div class="storeLogin">
              <loginMers />
            </div>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label" class="zhint"><img src="../assets/images/login/logo2.png">梅氏·综合服务平台</span>
            <iframe src="http://cloud.meishealth.com/#/loginMe" frameborder="0" scrolling="no" class="payNewIfra"></iframe>
          </el-tab-pane>
         </el-tabs>
         <div class="login-footMe">版权所有 © 2018-2028 苏州梅氏健康产业管理有限公司</div>
      </div>
    </el-container>
</template>
<script>
  import loginMers from '@/components/loginMers'
  export default {
    name: "Login",
    components:{loginMers},
    data() {
      return {
        activeName:'first',
        merLink:'http://cloud.meishealth.com/#'
      };
    },
    methods: {
      loginMer(e){
        top.location.href = e
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/Login.vue